module.exports = "<ag-mail\n  [model]=\"'enterprise'\"\n  [referenceId]=\"companyId\"\n  (send)=\"openMail($event)\"\n></ag-mail>\n"